import axios from "axios";
import { getToken } from "./tokenStore";
import { handleSessionOut } from "../HelperFunctions/HelperFunctions";
 const EXPORT_FILE_API = process.env.REACT_APP_File_Export_API;
const APP_AWS_API = process.env.REACT_APP_AWS_API;
const VERSION_CHECK_CLIENTS_API = process.env.REACT_APP_VERSION_CHECK_CLIENTS;
const SAVE_API = process.env.REACT_APP_BACKEND_API;



 
// no need to validate Token due to show in online from email
export const getDataToShowPDF = async (object_id) => {
  try {
    const responce = await axios.post(
      `${SAVE_API}/receive_customized_data`,
      { object_id },
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    if (responce.status != 200) {
      throw new Response("Failed to get the data", {
        status: 400,
      });
    }
    return responce.data;
  } catch (error) {
    throw new Response(`failed, ${error.message}`, {
      status: 500,
    });
  }
};

export async function getCustomizeData(payload) {
  const token = getToken();
  const response = await axios.get(`${SAVE_API}/get_home_customization`, {
    params: payload,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
}

// no need to validate Token
export async function getUserCustomizedData(
  userData,
  clientName,
  client_id,
  user_id,
  is_corp_legal,
) {
  const token = getToken();

  const { ly_budget_values, ...filteredColumnSettings } =
    userData.column_settings;

  const data = {
    client_name: clientName,
    client_id,
    user_id,
    token,
    is_corp_legal,
    only_variance: userData.column_settings.ly_budget_values,
    layout_settings: userData.layout_settings,
    column_settings: filteredColumnSettings,
    details: userData.details,
    corporations: userData.details.corporation,
    date: userData.details.date,
  };
  const response = await fetch(`${SAVE_API}/generate_report`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
  return response;
}

export async function getCustomeReportTableData(userIds) {
  const token = getToken();
  const response = await axios.post(
    `${SAVE_API}/custom_schedules_dashboard`,
    {
      user_ids: userIds,
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response.data;
}

export async function postReportSchedule(body) {
  // const body = { client_id, ...data }
   const token = getToken();
  const response = await axios.post(
    `${APP_AWS_API}/schedule`,
    body,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response;
}

export async function manualSendReport(payload) {
  const token = getToken();
  const response = await axios.post(`${APP_AWS_API}/manual_send`, payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  return response;
}

export async function UpdateSchedule(data) {
  const token = getToken();
  const response = await axios.post(`${APP_AWS_API}/schedule`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
}

export async function getUserEditedData(schedule_id) {
  const token = getToken();
  // Schedule metadata for edit dialog (FastAPI). Do not use AWS /schedule — that
  // Lambda only supports POST/PUT create/update, not GET.
  const response = await axios.get(`${SAVE_API}/get_edit_schedule`, {
    params: { schedule_id },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
}

export async function deleteCustomeReport(schedule_id) {
  const token = getToken();
  const response = await axios.delete(`${APP_AWS_API}/delete_schedule`, {
    params: { schedule_id },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
}

export async function downloadCustomeReport(clientName, schedule_id, date) {
  const token = getToken();
  const params = { client_id: clientName, schedule_id };
  // Optional: when omitted, API returns the last sent report for the schedule.
  if (date) {
    params.date = date;
  }
  const response = await axios.get(`${APP_AWS_API}/download_reports`, {
    params,
    headers: { Authorization: `Bearer ${token}` },
    responseType: "arraybuffer", // ← important for binary file bytes
  });
  return response;
}

export async function fetchCustomizeData(client_id, schedule_id) {
   const token = getToken();
  const response = await axios.get(
    `${SAVE_API}/get_schedule_customization`,
    {
      params: { client_id, schedule_id },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response;
}

export async function deleteCustomizeOptReport(client_id, schedule_id) {
  const token = getToken();
  const response = await axios.delete(
    `${SAVE_API}/delete_schedule_customization`,
    {
      params: { client_id, schedule_id },
      Authorization: `Bearer ${token}`,
    },
  );
  return response;
}

// no need to validate Token due to same end point used in airflow
export async function fetchAiInsights(payload) {
  const responce = await axios.post(
    `${SAVE_API}/generate_insights`,
    payload,
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
  return responce;
}

export async function checkDuplicateReportbook(
  report_book,
  client_id,
  schedule_id,
) {
  const token = getToken();
  const response = await axios.get(
    `${SAVE_API}/check_duplicate_reportbook`,
    {
      params: { client_id, report_book, schedule_id },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response.data;
}

// no need to validate Token due to same end point used in airflow
export async function exportCustoimizedFile(data) {
  const response = await axios.post(
    `${EXPORT_FILE_API}/export_flash-sale-format`,
    data,
    {
      headers: {
        "Content-Type": "application/json",
      },
      responseType: "blob",
    },
  );
  return response;
}

// no need to validate Token due to same end point used in airflow
export async function exportPDF(data) {
  const response = await axios.post(`${SAVE_API}/export_pdf`, data, {
    headers: {
      "Content-Type": "application/json",
    },
    responseType: "blob",
  });
  return response;
}

export async function v2Clients() {
  const token = getToken();
  const response = await axios.get(`${VERSION_CHECK_CLIENTS_API}/v2_clients`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  if (response && response?.status !== 200) {
    await handleSessionOut();
  }
  return response?.data;
}

export async function get_report_schedule(schedule_id) {
   const token = getToken();
  const response = await axios.get(
    `${SAVE_API}/get_report_schedule_customization`,
    {
      params: {   schedule_id },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  if (response && response?.status !== 200) {
    await handleSessionOut();
  }
  return response?.data;
}
